import { createReducer, on } from '@ngrx/store';
import * as fromProtection from '../actions/protection.action';
import { StateSlice } from '@core/helpers/state-slice';

export type ProtectionState = StateSlice<boolean>;

export const initialState: ProtectionState = {
  data: false,
  loaded: false,
  loading: false,
  error: null,
};

const protectionReducer = createReducer(
  initialState,
  on(fromProtection.addProtection, (state) => {
    return {
      ...state,
      data: true,
      loading: false,
      loaded: true,
    };
  }),
  on(fromProtection.resetProtection, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: ProtectionState | undefined,
  action: fromProtection.ProtectionActions
) {
  return protectionReducer(state, action);
}
